import { render, staticRenderFns } from "./table-grid-item.vue?vue&type=template&id=357079a0&scoped=true&"
import script from "./table-grid-item.vue?vue&type=script&lang=js&"
export * from "./table-grid-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357079a0",
  null
  
)

export default component.exports